import { showSuccessToast, showErrorToast } from '../../../shared/utils/toastManager';

import {
  CLEAR_VBT_DASH_LINK,
  CLEAR_VBT_DATA,
  CREATE_VBT_TEMPLATE_FULFILLED,
  CREATE_VBT_TEMPLATE_REJECTED,
  CREATE_VBT_TEMPLATE_START,
  DELETE_VBT_TEMPLATE_FULFILLED,
  DELETE_VBT_TEMPLATE_REJECTED,
  DELETE_VBT_TEMPLATE_START,
  DUPLICATE_VBT_TEMPLATE_FULFILLED,
  DUPLICATE_VBT_TEMPLATE_REJECTED,
  DUPLICATE_VBT_TEMPLATE_START,
  EDIT_VBT_TEMPLATE_FULFILLED,
  EDIT_VBT_TEMPLATE_REJECTED,
  EDIT_VBT_TEMPLATE_START,
  FETCH_ATHLETES_FULFILLED,
  FETCH_ATHLETES_REJECTED,
  FETCH_ATHLETES_START,
  FETCH_EXERCISES_FULFILLED,
  FETCH_EXERCISES_REJECTED,
  FETCH_EXERCISES_START,
  FETCH_GROUPS_FULFILLED,
  FETCH_GROUPS_REJECTED,
  FETCH_GROUPS_START,
  FETCH_PUBLIC_VBT_DATA_FULFILLED,
  FETCH_PUBLIC_VBT_DATA_REJECTED,
  FETCH_PUBLIC_VBT_DATA_START,
  FETCH_SHARE_VBT_DASH_LINK_FULFILLED,
  FETCH_SHARE_VBT_DASH_LINK_REJECTED,
  FETCH_SHARE_VBT_DASH_LINK_START,
  FETCH_VBT_DATA_FULFILLED,
  FETCH_VBT_DATA_REJECTED,
  FETCH_VBT_DATA_START,
  FETCH_VBT_TEMPLATES_FULFILLED,
  FETCH_VBT_TEMPLATES_REJECTED,
  FETCH_VBT_TEMPLATES_START,
  SET_ABOUT_VBT_DASH_MODAL,
  SET_ACTIVE_VBT_DASH,
  SET_DATE_RANGE,
  SET_DELETE_VBT_DASH_MODAL,
  SET_DUPLICATE_VBT_DASH_MODAL,
  SET_EDIT_VBT_DASH_MODAL,
  SET_END_DATE_DATA,
  SET_EXERCISES,
  SET_GRAPH_THRESHOLDS,
  SET_GROUP,
  SET_GROUPS,
  SET_IS_FILTER_SHOWING,
  SET_IS_VBT_DASH_DISPLAYED,
  SET_NEW_VBT_DASH,
  SET_NEXT_LOCATION,
  SET_SAVE_VBT_DASH_MODAL,
  SET_SELECTED_ATHLETE,
  SET_SELECTED_END_DATE_ANALYSIS,
  SET_SELECTED_END_DATE_OVERVIEW,
  SET_SELECTED_EXERCISE,
  SET_SHARE_VBT_DASH_MODAL,
  SET_START_DATE,
  SET_TABLE_THRESHOLD,
  SET_UNSAVED_VBT_DASH_MODAL,
  SET_VBT_DASH_VIEW,
  SET_VBT_ONBOARDING_MODAL,
} from './actionTypes';

import { axiosAuthed, axiosUnauthed } from '../../../shared/utils/setCommonHeaders';

export const clearVBTData = () => ({
  type: CLEAR_VBT_DATA,
});

export const clearShareVBTDashLink = () => ({
  type: CLEAR_VBT_DASH_LINK,
});

export const createVBTTemplate = (accountCode, subObj) => (
  (dispatch) => {
    dispatch({ type: CREATE_VBT_TEMPLATE_START });
    axiosAuthed
      .post(`/accounts/${accountCode}/reports/vbt/templates`, subObj)
      .then((response) => {
        showSuccessToast('Dashboard Created!');
        dispatch({
          payload: response.data,
          type: CREATE_VBT_TEMPLATE_FULFILLED,
        });
      })
      .catch((err) => {
        showErrorToast(err?.response?.headers?.message || 'An error has occurred');
        dispatch({
          payload: err,
          type: CREATE_VBT_TEMPLATE_REJECTED,
        });
      });
  }
);

export const deleteVBTTemplate = (accountCode, tempId, tempIdx) => (
  (dispatch) => {
    dispatch({ type: DELETE_VBT_TEMPLATE_START });
    axiosAuthed
      .delete(`/accounts/${accountCode}/reports/vbt/templates/${tempId}`)
      .then((response) => {
        showSuccessToast('Dashboard Deleted!');
        dispatch({
          payload: {
            data: response.data,
            index: tempIdx,
          },
          type: DELETE_VBT_TEMPLATE_FULFILLED,
        });
      })
      .catch((err) => {
        showErrorToast(err?.response?.headers?.message || 'An error has occurred');
        dispatch({
          payload: err,
          type: DELETE_VBT_TEMPLATE_REJECTED,
        });
      });
  }
);

export const duplicateVBTTemplate = (accountCode, tempId, subObj) => (
  (dispatch) => {
    dispatch({ type: DUPLICATE_VBT_TEMPLATE_START });
    axiosAuthed
      .post(`/accounts/${accountCode}/reports/vbt/templates/${tempId}/duplicate`, subObj)
      .then((response) => {
        showSuccessToast('Dashboard Duplicated!');
        dispatch({
          payload: response.data,
          type: DUPLICATE_VBT_TEMPLATE_FULFILLED,
        });
      })
      .catch((err) => {
        showErrorToast(err?.response?.headers?.message || 'An error has occurred');
        dispatch({
          payload: err,
          type: DUPLICATE_VBT_TEMPLATE_REJECTED,
        });
      });
  }
);

export const editVBTTemplate = (accountCode, subObj, tempId, tempIdx) => (
  (dispatch) => {
    dispatch({ type: EDIT_VBT_TEMPLATE_START });
    axiosAuthed
      // 'resetExercises=true'
      // And omit exerciseIds in payload to remove all existing exercises from template
      .put(`/accounts/${accountCode}/reports/vbt/templates/${tempId}`, subObj)
      .then((response) => {
        showSuccessToast('Edit Successful!');
        dispatch({
          payload: {
            data: response.data,
            index: tempIdx,
          },
          type: EDIT_VBT_TEMPLATE_FULFILLED,
        });
      })
      .catch((err) => {
        showErrorToast(err?.response?.headers?.message || 'An error has occurred');
        dispatch({
          payload: err,
          type: EDIT_VBT_TEMPLATE_REJECTED,
        });
      });
  }
);

export const fetchAthletes = (accountCode, groupId) => (
  (dispatch) => {
    dispatch({ type: FETCH_ATHLETES_START });
    axiosAuthed.get(`/accounts/${accountCode}/groups/${groupId}/user-detail`)
      .then((response) => {
        const cleanedArray = [
          ...response.data
            .map(({ id, first, last }) => ({
              fullName: `${first} ${last}`,
              id,
            }))
            .sort((a, b) => a.fullName.localeCompare(b.fullName)),
        ];
        dispatch({
          payload: cleanedArray,
          type: FETCH_ATHLETES_FULFILLED,
        });
      })
      .catch((err) => {
        showErrorToast(err?.response?.headers?.message || 'An error has occurred');
        dispatch({
          payload: err,
          type: FETCH_ATHLETES_REJECTED,
        });
      });
  }
);

export const fetchExercises = (accountCode) => (
  (dispatch) => {
    dispatch({ type: FETCH_EXERCISES_START });
    axiosAuthed.get(`/accounts/${accountCode}/reports/vbt/exercises`)
      .then((response) => {
        dispatch({
          type: FETCH_EXERCISES_FULFILLED,
          payload: response.data,
        });
      })
      .catch((err) => {
        showErrorToast(err?.response?.headers?.message || 'An error has occurred');
        dispatch({
          type: FETCH_EXERCISES_REJECTED,
          payload: err,
        });
      });
  }
);

export const fetchGroups = (accountCode) => (
  (dispatch) => {
    dispatch({ type: FETCH_GROUPS_START });
    axiosAuthed.get(`/accounts/${accountCode}/groups?reporting=1`)
      .then((response) => {
        dispatch({
          payload: response.data.sort((a, b) => a.name.localeCompare(b.name)),
          type: FETCH_GROUPS_FULFILLED,
        });
      })
      .catch((err) => {
        dispatch({
          payload: err,
          type: FETCH_GROUPS_REJECTED,
        });
      });
  }
);

export const fetchPublicVBTData = (exerId, token) => (
  (dispatch) => {
    const urlString = exerId ? `/public/reports/vbt?token=${token}&exerciseId=${exerId}` : `/public/reports/vbt?token=${token}`;
    dispatch({ type: FETCH_PUBLIC_VBT_DATA_START });
    axiosUnauthed.get(urlString)
      .then((response) => {
        dispatch({
          payload: response.data,
          type: FETCH_PUBLIC_VBT_DATA_FULFILLED,
        });
      })
      .catch((err) => {
        showErrorToast(err?.response?.headers?.message || 'An error has occurred');
        dispatch({
          payload: true,
          type: FETCH_PUBLIC_VBT_DATA_REJECTED,
        });
      });
  }
);

export const fetchShareVBTDashLink = (accountCode, subObj) => (
  (dispatch) => {
    dispatch({ type: FETCH_SHARE_VBT_DASH_LINK_START });
    axiosAuthed.post(`/accounts/${accountCode}/reports/vbt/link`, subObj)
      .then((response) => {
        dispatch({
          payload: response.data.url,
          type: FETCH_SHARE_VBT_DASH_LINK_FULFILLED,
        });
      })
      .catch((err) => {
        showErrorToast(err?.response?.headers?.message || 'An error has occurred');
        dispatch({
          payload: true,
          type: FETCH_SHARE_VBT_DASH_LINK_REJECTED,
        });
      });
  }
);

export const fetchVBTData = (accountCode, endDate, exerId, groupId, startDate) => (
  (dispatch) => {
    dispatch({ type: FETCH_VBT_DATA_START });
    axiosAuthed
      .get(`/accounts/${accountCode}/reports/vbt?endDate=${endDate}&exerciseId=${exerId}&groupId=${groupId}&startDate=${startDate}`)
      .then((response) => {
        dispatch({
          payload: response.data,
          type: FETCH_VBT_DATA_FULFILLED,
        });
      })
      .catch((err) => {
        dispatch({
          payload: err,
          type: FETCH_VBT_DATA_REJECTED,
        });
      });
  }
);

export const fetchVBTTemplates = (accountCode) => (
  (dispatch) => {
    dispatch({ type: FETCH_VBT_TEMPLATES_START });
    axiosAuthed
      .get(`/accounts/${accountCode}/reports/vbt/templates`)
      .then((response) => {
        dispatch({
          payload: response.data,
          type: FETCH_VBT_TEMPLATES_FULFILLED,
        });
      })
      .catch((err) => {
        dispatch({
          payload: err,
          type: FETCH_VBT_TEMPLATES_REJECTED,
        });
      });
  }
);

export const setAboutVBTDashModal = (bool, template = {}) => ({
  payload: {
    bool,
    template,
  },
  type: SET_ABOUT_VBT_DASH_MODAL,
});

export const setActiveVBTDash = (obj) => ({
  payload: obj,
  type: SET_ACTIVE_VBT_DASH,
});

export const setDateRange = (range) => ({
  payload: range,
  type: SET_DATE_RANGE,
});

export const setDeleteVBTDashModal = (bool, template = {}) => ({
  payload: {
    bool,
    template,
  },
  type: SET_DELETE_VBT_DASH_MODAL,
});

export const setDuplicateVBTDashModal = (bool, template = {}) => ({
  payload: {
    bool,
    template,
  },
  type: SET_DUPLICATE_VBT_DASH_MODAL,
});

export const setEditVBTDashModal = (bool, template = {}) => ({
  payload: {
    bool,
    template,
  },
  type: SET_EDIT_VBT_DASH_MODAL,
});

export const setEndDateData = (date) => ({
  payload: date,
  type: SET_END_DATE_DATA,
});

export const setExercises = (exercises) => ({
  payload: exercises.sort((a, b) => a.name.localeCompare(b.name)),
  type: SET_EXERCISES,
});

export const setGraphThresholds = (array) => ({
  payload: array,
  type: SET_GRAPH_THRESHOLDS,
});

export const setGroup = (group) => ({
  payload: group,
  type: SET_GROUP,
});

export const setGroups = (groups) => ({
  payload: groups.sort((a, b) => a.name.localeCompare(b.name)),
  type: SET_GROUPS,
});

export const setIsFilterShowing = (bool) => ({
  payload: bool,
  type: SET_IS_FILTER_SHOWING,
});

export const setIsNewVBTDash = (bool) => ({
  payload: bool,
  type: SET_NEW_VBT_DASH,
});

export const setIsVBTDashDisplayed = (bool) => ({
  payload: bool,
  type: SET_IS_VBT_DASH_DISPLAYED,
});

export const setNextVBTDashLocation = (location) => ({
  payload: location,
  type: SET_NEXT_LOCATION,
});

export const setOnboardingModal = (bool) => ({
  payload: bool,
  type: SET_VBT_ONBOARDING_MODAL,
});

export const setSaveVBTDashModal = (bool) => ({
  payload: bool,
  type: SET_SAVE_VBT_DASH_MODAL,
});

export const setSelectedAthlete = (athlete, bool) => ({
  payload: {
    athlete,
    bool,
  },
  type: SET_SELECTED_ATHLETE,
});

export const setSelectedEndDateAnalysis = (date) => ({
  payload: date,
  type: SET_SELECTED_END_DATE_ANALYSIS,
});

export const setSelectedEndDateOverview = (date) => ({
  payload: date,
  type: SET_SELECTED_END_DATE_OVERVIEW,
});

export const setSelectedExercise = (bool, exer) => ({
  payload: {
    bool,
    exer,
  },
  type: SET_SELECTED_EXERCISE,
});

export const setShareVBTDashModal = (bool, template = {}) => ({
  payload: {
    bool,
    template,
  },
  type: SET_SHARE_VBT_DASH_MODAL,
});

export const setStartDate = (date) => ({
  payload: date,
  type: SET_START_DATE,
});

export const setTableThreshold = (obj) => ({
  payload: obj,
  type: SET_TABLE_THRESHOLD,
});

export const setUnsavedVBTDashModal = (bool) => ({
  payload: bool,
  type: SET_UNSAVED_VBT_DASH_MODAL,
});

export const setVBTDashView = (view) => ({
  payload: view,
  type: SET_VBT_DASH_VIEW,
});
